import React from 'react'
import {MatricesPromociones} from "../components/marketing/MatricesPromociones";

export const MatrizPromocionesPage = () => {
    return (
        <MatricesPromociones/>
    )
}
